import React, { memo } from 'react';
import { Calendar, Truck, Sparkles } from 'lucide-react';
export const HowItWorksSection = () => {
  const steps = [{
    number: 1,
    icon: Calendar,
    title: 'Pick Your Package',
    description: 'Browse our collection of soft play sets, bounce houses, and add-ons. Choose what fits your space and budget.'
  }, {
    number: 2,
    icon: Truck,
    title: 'We Deliver & Set Up',
    description: 'We arrive early, handle all the setup, and ensure everything is safe and ready for playtime.'
  }, {
    number: 3,
    icon: Sparkles,
    title: 'We Clean Up & Pack Away',
    description: 'After the fun, we take care of everything. You enjoy the party stress-free while we handle the rest.'
  }];
  return <section className="bg-white py-16 md:py-24" data-id="element-319">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-320">
        <div className="text-center mb-16" data-id="element-321">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-gray-900 mb-4" data-id="element-322">
            How It Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-323">
            Three simple steps to create magical memories for your little ones
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-324">
          {steps.map((step, index) => <div key={step.number} className="relative" data-id="element-325">
              {index < steps.length - 1 && <div className="hidden md:block absolute top-16 left-1/2 w-full h-0.5 bg-primary-200 -z-10" data-id="element-326" />}

              <div className="text-center" data-id="element-327">
                <div className="relative inline-flex items-center justify-center w-32 h-32 mb-6" data-id="element-328">
                  <div className="absolute inset-0 bg-secondary-100 rounded-full" data-id="element-329"></div>
                  <div className="relative bg-secondary-500 rounded-full w-24 h-24 flex items-center justify-center shadow-lg" data-id="element-330">
                    <step.icon className="w-12 h-12 text-white" strokeWidth={2} data-id="element-331" />
                  </div>
                  <div className="absolute -top-2 -right-2 bg-primary-600 text-white rounded-full w-10 h-10 flex items-center justify-center font-heading font-bold text-xl shadow-md" data-id="element-332">
                    {step.number}
                  </div>
                </div>

                <h3 className="text-2xl font-heading font-bold text-gray-900 mb-3" data-id="element-333">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-334">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};